module.exports = __webpack_public_path__ + "img/01-1医疗健康.589b2497.png";